import { list } from '@fitogest/reactive-form-builder/utils';
import {
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
    DropdownData,
    InputType,
} from '@fitogest/reactive-form-builder/interfaces';
import { ClienteModel } from 'src/app/models/cliente.model';
import { ObraModel } from 'src/app/models/ventas/tablas-maestras.model';
import { environment } from 'src/environments/environment';

export class ObraFormDefinition {
  public readonly appName = environment.appName;
  public lastFieldChanged = '';
  public requestType: FormType = FormType.CREATION;
  public model: Partial<ObraModel> = {};
  public clientes: DropdownData<ClienteModel> = list<ClienteModel>();
  public formFields: Form<ObraModel>;

  constructor(type: FormType, model: Partial<ObraModel>) {
    this.requestType = type;
    this.model = model;
    this.formFields = {
      name: 'obra',
      header: 'Datos de la obra',
      type: +type as FormType,
      sections: this.getSections(),
      table: null,
      uploadButton: {
        isEnabled: false,
        label: '',
      },
      signed: false,
    };
  }

  public handleFormValueChange(tag: string): void {
    this.lastFieldChanged = tag;
  }

  private getSections(): FormSection<ObraModel>[] {
    return [
      {
        name: '',
        fields: this.getFields(),
        width: 12,
        isVisible: true,
        order: 1,
      },
    ];
  }

  private getFields(): FormField<ObraModel>[] {
    return [
      {
        name: 'nombre',
        label: 'Nombre',
        input: {
          type: InputType.TEXT,
          isEditable: true,
        },
        width: 4,
        conditions: this.conditions({ isRequired: true }),
        order: 1,
      },
      {
        name: 'cliente',
        label: 'Cliente',
        input: {
          type: InputType.DROPDOWN_SEARCH,
          isEditable: true,
          data: this.clientes,
          dropdownConfiguration: {
            valuePrimaryKey: 'id',
          },
        },
        width: 4,
        conditions: this.conditions({ isRequired: true }),
        order: 2,
      },
    ];
  }

  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }
}
